import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll position of #root container on route changes
 * This fixes iOS white space issue when navigating between pages
 */
export const useScrollReset = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      // Reset scroll to top
      root.scrollTo(0, 0);
    }
    
    // Force header repaint on iOS to prevent layout shift
    const header = document.querySelector('.auto-hide-header') as HTMLElement;
    if (header) {
      header.style.transform = 'translateZ(0)';
      requestAnimationFrame(() => {
        header.style.transform = '';
      });
    }
    
    // Also reset any stuck scroll direction state
    window.dispatchEvent(new CustomEvent('route-change'));
  }, [pathname]);
};
